module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs c-split-screen p-day-one"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theCurrentWidth < 1024),
      expression: "theCurrentWidth < 1024"
    }]
  }, [_c('header-section', {
    attrs: {
      "set-position": "relative",
      "set-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-split-screen__container"
  }, [_c('div', {
    staticClass: "c-split-screen__column-one"
  }, [_c('h1', [_vm._v("Day One Reserve Tool")]), _vm._v(" "), _c('p', [_vm._v("\n                Our unique reserving function allows you to perform accurate day one assessments of reserves based on your claims history.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Enter your claim type to start the reserving function")]), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "for": "",
      "label": "Enter Claim Type",
      "icon-space": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedClaimType),
      expression: "selectedClaimType"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedClaimType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.route]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v("Please Select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fatal"
    }
  }, [_vm._v("Fatal Accident Claim")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost"
    }
  }, [_vm._v("Lost Years Claim")])])]), _vm._v(" "), _c('router-view', {
    staticClass: "u-margin-bottom-20",
    attrs: {
      "name": "form"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-split-screen__column-two"
  }, [_c('router-view', {
    staticClass: "u-margin-bottom-20",
    attrs: {
      "name": "results"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-473a861d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/components/DayOneSimple.vue
// module id = 1670
// module chunks = 0